import { NavLink } from "@/db/navLinks";
import Image from "next/image";
import Link from "next/link";
import MenuItem from "./menuItem";
import MobileNavbar from "./mobileNavbar";
import { FiUser } from "react-icons/fi";
import { PRIVATE_WEBSITE_URL } from "@/constants/env";


interface NavigationProps {
  logo: string;
  navLinks: NavLink[];
}

const Navigation: React.FC<NavigationProps> = ({ navLinks }) => {


  return (
    <>
      <MobileNavbar />
      <div className="lanklub-nav">
        <div className="container">
          <nav className="navbar navbar-expand-md navbar-light bg-light">
            <Link className="navbar-brand" href="/">
              <Image
                width={172}
                height={90}
                src="/images/common/Ashva.png"
                alt="logo"
              />
            </Link>
            <div className="collapse navbar-collapse mean-menu">
              <ul className="navbar-nav mx-auto">
                {navLinks.map((link, index) => (
                  <MenuItem key={index} item={link} />
                ))}
              </ul>
              <div className="btn-box d-flex m-3 gap-3">

                <Link href="/enquiryPage" className="default-btn text-nowrap">
                  Enroll
                </Link>

                <Link href="/applicationTracker" className="default-btn3 text-nowrap">
                  Track Application
                </Link>
                <div className="d-flex align-items-center loginlinks">
                  <Link
                    href={PRIVATE_WEBSITE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Login"
                    className="login-icon-link"
                  >
                    <FiUser className="login-icon" />
                  </Link>
                </div>
              </div>



            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Navigation;

